export default __webpack_public_path__ + "static/media/about-page-img.a86b5edb.png";